import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Features from "../../components/Features";
import Product from "../../components/Product";
import Banner from "../../components/Banner";
import Categories from "../../components/Categories";
import Offers from "../../components/Offers";
import Vendor from "../../components/Vendor";
import ProceedToCheckoutView from "../../components/ProceedToCheckoutView";
import Blogs from "../../components/Blogs";
import ColorCustomizer from "../../components/ColorCustomizer";
import "../../css/custom-colors.css";
import { blogs_show_more } from "../../data/Data";
import { filterSeasonalContent } from "../../config/seasons";
import Seo from "../../components/Seo";

import { routeMeta } from "../../seo/staticRoutes";
export default function Home() {
  const navigate = useNavigate();

  /**
   * Scent families, each tied to the fragrances we actually sell.
   *
   * These were four flat colour blocks with a sentence of copy and nothing to
   * click — describing something invisible without ever naming a product.
   * Listing the real fragrances turns each card into a route into the
   * catalogue, and `key` drives a per-family "scent bloom" in the CSS.
   */
  const matrixCards = [
    {
      key: "floral",
      title: "Floral",
      description: "Soft, calming bouquets for mindful evenings.",
      notes: [
        { name: "Rose", to: "/item/Rose_Zipper" },
        { name: "Mogra", to: "/item/Mogra_Super" },
        { name: "Chameli", to: "/item/Chameli_Jar" },
        { name: "Rajnigandha", to: "/item/Rajnigandha" },
        { name: "White Gulab", to: "/item/White_Gulab_Jar" },
      ],
    },
    {
      key: "woody",
      title: "Woody",
      description: "Deep, grounding resins for daily ritual.",
      notes: [
        { name: "Sandal", to: "/item/Sandal_Jar" },
        { name: "Oudh", to: "/item/Oudh_box" },
        { name: "Guggal", to: "/item/Guggal_Jar" },
        { name: "Loban", to: "/item/Loban_Jar" },
      ],
    },
    {
      key: "exotic",
      title: "Exotic",
      description: "Spice-rich profiles with a warm, resinous finish.",
      notes: [
        { name: "Kasturi", to: "/item/Kasturi" },
        { name: "Ruh Heena", to: "/item/Ruh_Heena" },
        { name: "Kewda", to: "/item/Kewda" },
        { name: "Firangipani", to: "/item/Firangipani_box" },
      ],
    },
    {
      key: "fresh",
      title: "Fresh",
      description: "Clean, airy notes for everyday calm.",
      notes: [
        { name: "White Musk", to: "/item/White_Musk_Jar" },
        { name: "Lavender", to: "/item/Lavender" },
        { name: "Muskan", to: "/item/Muskan_Jar" },
        { name: "3 in 1", to: "/item/3_in_1_Zipper" },
      ],
    },
  ];

  return (
    <>
      <Seo {...routeMeta("/")} />
      <Banner />
      <section className="fragrance-matrix-section">
        <div className="container-fluid">
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <span className="section-badge">Shop by Fragrance</span>
              <h2 className="section-title-professional">Find your scent</h2>
              <p className="section-subtitle-professional">
                Four families, and the fragrances we actually make in each. Start with a
                mood and follow it to a jar.
              </p>
            </div>
          </div>
          <div className="fragrance-matrix-grid">
            {matrixCards.map((card) => (
              <article className={`scent-card scent-${card.key}`} key={card.key}>
                <span className="scent-bloom" aria-hidden="true"></span>
                <div className="scent-body">
                  <h4>{card.title}</h4>
                  <p>{card.description}</p>
                  <ul className="scent-notes">
                    {card.notes.map((note) => (
                      <li key={note.name}>
                        <Link to={note.to}>{note.name}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
          <div className="row mt-4">
            <div className="col-12 text-center">
              <button className="btn-professional-secondary" onClick={() => navigate('/wholesale')}>
                Explore Wholesale Pricing
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* <Features /> */}
      <Categories />
      <Product />
      <Blogs
        blogsData={filterSeasonalContent(blogs_show_more)}
      />
      <Offers />
      <ProceedToCheckoutView />
      {/* <Vendor /> */}
      {/* <ColorCustomizer /> */}
    </>
  );
}
